export function isOnline(lastSeen: string | Date | null, now: Date, thresholdMinutes = 5): boolean {
  if (!lastSeen) return false
  const seen = typeof lastSeen === 'string' ? new Date(lastSeen) : lastSeen
  return now.getTime() - seen.getTime() <= thresholdMinutes * 60_000
}

export function deviceLabelFromUA(ua: string | null): string {
  if (!ua) return 'Desconocido'
  const browser =
    /Edg\//.test(ua)                        ? 'Edge'
    : /Chrome\//.test(ua) && !/Edg\//.test(ua) ? 'Chrome'
    : /Firefox\//.test(ua)                  ? 'Firefox'
    : /Safari\//.test(ua) && !/Chrome\//.test(ua) ? 'Safari'
    : 'Navegador'
  const os =
    /iPhone/.test(ua)                       ? 'iPhone'
    : /iPad/.test(ua)                       ? 'iPad'
    : /Android/.test(ua)                    ? 'Android'
    : /Macintosh|Mac OS X/.test(ua)         ? 'Mac'
    : /Windows/.test(ua)                    ? 'Windows'
    : /Linux/.test(ua)                      ? 'Linux'
    : 'Otro'
  return `${browser} · ${os}`
}

const ACTION_ES: Record<string, string> = {
  login:           'Inicio de sesión',
  login_failed:    'Intento fallido',
  logout:          'Cierre de sesión',
  token_refreshed: 'Sesión renovada',
  token_revoked:   'Sesión revocada',
}
export function actionLabelEs(action: string): string {
  return ACTION_ES[action] ?? action
}

export interface PresenceInput {
  userId: string
  clinicId: string | null
  role: string | null
  route: string | null
  userAgent: string | null
  isImpersonated: boolean
  nowIso: string
}
export function buildPresenceRow(i: PresenceInput) {
  return {
    user_id:         i.userId,
    clinic_id:       i.clinicId,
    role:            i.role,
    last_seen:       i.nowIso,
    user_agent:      i.userAgent,
    current_route:   i.route,
    is_impersonated: i.isImpersonated,
  }
}
